// extracted by mini-css-extract-plugin
export default {"blockFull":"fullInfoBlock_blockFull__ZkXZj","description":"fullInfoBlock_description__C3ZR6","data":"fullInfoBlock_data__TEkzj"};